import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";
import { clearAllAuthData } from "../utils/secureStorage";

const isDevelopment = process.env.NODE_ENV === "development";

/**
 * ✅ Production-ready Logout component
 * Handles user logout and redirects to home page with robust fallback mechanisms
 */
const Logout = () => {
  const navigate = useNavigate();
  const context = useAuthContext();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await context.logout();
        clearAllAuthData();
        navigate("/login");
      } catch (error) {
        if (!isDevelopment && window.errorReporting) {
          window.errorReporting.captureException(error);
        }
        // Still navigate to login even if there's an error
        navigate("/login");
      }
    };

    performLogout();
  }, [context, navigate]);

  return null;
};

export default Logout;
